import React, { Component } from 'react';
import { BarChart, Bar, YAxis, XAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer, ReferenceLine } from 'recharts';
import { blue, red } from '@material-ui/core/colors';

const graphColors = [blue[300], red[400]];

class BarGraph extends Component {
  state = {
    barWidth: 20
  };

  refArea = null;
  barWidthSet = false;

  componentDidMount() {
    this.updateDimensions();

    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate() {
    this.updateDimensions();
  }

  updateDimensions = () => {
    if (!this.refArea) {
      return;
    }

    const barWidth = this.refArea.props.xAxis.width / this.refArea.props.xAxis.domain.length;

    if (barWidth === this.state.barWidth) {
      return;
    }

    this.barWidthSet = true;

    this.setState({
      barWidth
    });
  }

  select = (data) => {
    if (!data || !this.props.onSelect) {
      return;
    }

    let selected = data.activeLabel;

    if (selected === this.props.selected) {
      selected = null
    }

    this.props.onSelect(selected);
  };

  render() {
    return (
      <ResponsiveContainer className="no-select">
        <BarChart
          data={this.props.data}
          barGap={2}
          onClick={this.select}
        >
          <ReferenceLine
            y={0}
            stroke="#f00"
          />

          {
            !this.props.noLegend &&
            <Legend />
          }

          <Tooltip
            cursor={{fill: '#ddd'}}
            separator=": "
            labelFormatter={data => this.props.labelFormatter(data)}
          />

          <CartesianGrid vertical={false} stroke="#eee" />

          <ReferenceLine
            x={this.props.selected}
            stroke="#f44336"
            strokeOpacity={0.5}
            strokeWidth={this.state.barWidth}
          />

          {
            this.props.values.map((set, index) =>
              <Bar
                key={index}
                name={'Summa'}
                unit=" €"
                dataKey={set.key}
                fill={graphColors[index]}
                animationDuration={600}
              />
            )
          }
          {
            !this.props.hideY &&
            <YAxis mirror={this.props.mirrorY || this.props.mirror} />
          }
          <XAxis mirror={this.props.mirror} dataKey={this.props.xKey} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default BarGraph;
